export default __webpack_public_path__ + "static/media/title&escrow.0c3d271a.svg";